module.exports = __webpack_public_path__ + "images/stickers/thumbsdown@2x.4a69de4af1faba884665.png";